import { ref, watch } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

import { type VisibilityState } from "@tanstack/vue-table";

export const useMemoColumnVisibility = (
  key: string,
  defaultHiddenColumns: VisibilityState = {},
) => {
  const cookies = useCookies();
  const columnVisibilityFromCookies =
    cookies.get(key) || ({} as VisibilityState);

  const columnVisibility = ref<VisibilityState>({
    ...defaultHiddenColumns,
    ...columnVisibilityFromCookies,
  });

  const memoizeColumnVisibility = () => {
    cookies.set(key, {
      ...columnVisibility.value,
    });
  };

  watch(
    () => columnVisibility.value,
    () => memoizeColumnVisibility(),
  );

  return {
    columnVisibility,
  };
};

export default {};
